import { ICONS } from '@frontend/icons';
import { useModals } from '@frontend/modal';
import { FormattedMessage } from 'react-intl';

interface PreviewHTMLProps {
    content: string;
}

export const PreviewHTML = (props: PreviewHTMLProps) => {
    const { closeTopModal } = useModals();
    return (
        <div className='bg-background-surface outline-border-default inline-flex w-full min-w-fit flex-col items-center justify-center gap-6 rounded-md p-6 outline-1 outline-offset-[-1px]'>
            <div className='inline-flex flex-col items-start justify-start gap-2 self-stretch'>
                <div className='inline-flex h-6 items-center justify-between self-stretch'>
                    <div className='text-foreground-default text-lg font-semibold'>
                        <FormattedMessage
                            id='preview.html.title'
                            defaultMessage='Preview HTML'
                        />
                    </div>
                    <ICONS.BUTTON.CLOSE
                        className='hover:cursor-pointer'
                        onClick={closeTopModal}
                    />
                </div>
                <div
                    className='inline-flex h-fit w-full items-center justify-center'
                    dangerouslySetInnerHTML={{ __html: props.content }}
                />
            </div>
        </div>
    );
};
